import config from '../../app.json';
import axios from 'axios';

import Modal from 'react-bootstrap/Modal';
import './conversation.scss';
import 'highlight.js/styles/github-dark.css';

import hljs from 'highlight.js';

import { saveAs } from 'file-saver';
import { HubConnectionState } from '@microsoft/signalr';
import { Context } from '../../Reducers/Store';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import FieldTextarea from '../Fields/FieldTextarea';
import Image from '../Image/image';
import moment from 'moment';
import 'moment-timezone';
import { Tabs, Tab } from 'react-bootstrap';
import Popup from '../Popup/popup';
import FieldSelect from '../Fields/FieldSelect';

import UserAvatar from '../../Assets/Images/avatar-sc.png';
import RobotAvatar from '../../Assets/Images/white-monkey.svg';
import GenerationError from '../../Assets/Images/chat-generation-error.png';
import GenerationDelay from '../../Assets/Images/chat-generation-delay.png';
import HootSuiteBox from '../HootSuiteBox/hootsuitebox';

function Conversation(props) {
  const [state, dispatch] = useContext(Context);
  const [title, setTitle] = useState(null);
  const [messages, setMessages] = useState([]);
  const [userMessage, setUserMessage] = useState('');
  const [messageGpt, setMessageGpt] = useState(null);
  const messagesRef = useRef(null);
  const [activeTab, setActiveTab] = useState('0');
  const [isPopupOpen, setPopupOpen] = useState(false);
  const fullMessages = useRef(null);
  const readableMessages = useRef(null);
  const refreshTimer = useRef(null);
  const [shouldScrollToBottom, setShouldScrollToBottom] = useState(true);
  const [showInpaint, setShowInpaint] = useState(null);

  const [language, setLanguage] = useState({
    value: 'English',
    label: 'English',
  });

  const [voice, setVoice] = useState({
    value: 'Female',
    label: 'Female',
  });

  const [personality, setPersonality] = useState({
    value: 'Friendly',
    label: 'Friendly',
  });

  const getCurrentTime = () => {
    const currentDate = new Date();
    return moment(currentDate).format('YYYY-MM-DDTHH:mm:ss.SSSSS[Z]');
  };

  const refreshDelays = () => {
    setMessages([...messages]);
  };

  const handleScroll = () => {
    const divScroll = document.querySelector('.auto-refresh');
    const { scrollTop, clientHeight, scrollHeight } = divScroll;
    const atBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    if (atBottom) {
      setShouldScrollToBottom(true);
    } else {
      setShouldScrollToBottom(false);
    }
  };

  const scrollToBottom = () => {
    const divScroll = document.querySelector('.auto-refresh');

    divScroll.scrollTo({
      top: divScroll.scrollHeight,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    if (shouldScrollToBottom) {
      scrollToBottom();
    }
  }, [shouldScrollToBottom]);

  useEffect(() => {
    /* Function to close inpaint modal */
    function handlePostMessage(event) {
      if (
        event != null &&
        event.isTrusted &&
        event.data != null &&
        event.origin == 'https://936929561302675456.discordsays.com' &&
        event.data[0] == 2 &&
        event.data[1].code == 1000
      )
        setShowInpaint(null);
    }
    window.addEventListener('message', handlePostMessage);

    const divScroll = document.querySelector('.auto-refresh');
    divScroll.addEventListener('scroll', handleScroll);
    hljs.initHighlightingOnLoad();
    return () => {
      window.removeEventListener('message', handlePostMessage);
      divScroll.removeEventListener('scroll', handleScroll);
    };
  }, [0]);

  useEffect(() => {
    if (props.currentItem) {
      setTitle(props.currentItem.name);

      axios
        .get(config.API_HM + '/chatmessages?chatId=' + props.currentItem.id)
        .then((resC) => {
          fullMessages.current = resC.data.reverse().map((x) => {
            x.who = x.who || 'bot';
            return x;
          });

          fullMessages.current = fullMessages.current.filter(
            (x) => !x.isInpaint
          );

          // DEBUG ERROR SIMULATED
          //fullMessages.current.at(-1).error = true;
          //fullMessages.current.at(-1).message = "We cannot fulfill that request due to ethical guidelines. Ask anything else and we'll be glad to help!";

          readableMessages.current = fullMessages.current.filter(
            (x) => x.who.toLowerCase() != 'bot'
          );
          let withRelated = fullMessages.current.filter(
            (x) => x.who.toLowerCase() == 'bot'
          );
          readableMessages.current.forEach((element) => {
            var currentRelated = withRelated
              .filter((x) => x.relatedId == element.id)
              .at(0);
            if (currentRelated) {
              currentRelated = withRelated
                .splice(withRelated.indexOf(currentRelated), 1)
                .pop();
              element.related = currentRelated;
              currentRelated.parent = element;
            }
          });

          if (withRelated.length > 0) {
            withRelated.forEach((e) => (e.solo = true));
            readableMessages.current = [
              ...readableMessages.current,
              ...withRelated,
            ];
          }

          readableMessages.current = readableMessages.current.sort(
            (a, b) => new Date(a.when) - new Date(b.when)
          );

          setMessages(readableMessages.current);

          setShouldScrollToBottom(true);
          scrollToBottom();
        })
        .catch(function (error) {});
    } else {
      setTitle(``);
      fullMessages.current = [];
      setMessages([]);
    }
  }, [props.currentItem]);

  useEffect(() => {
    if (props.botMessage) {
      const theBotMessage = {
        who: 'bot',
        ...props.botMessage,
      };

      if (theBotMessage.isInpaint) {
        setShowInpaint(theBotMessage.message);
        return;
      }

      // Remove the temporary message
      fullMessages.current = fullMessages.current.filter(
        (x) => x.id != props.botMessage.id
      );
      readableMessages.current = readableMessages.current.filter(
        (x) => x.id != props.botMessage.id
      );

      // Add this new message
      fullMessages.current.push(theBotMessage);
      if (theBotMessage.who.toLowerCase() != 'bot') {
        var currentRelated = fullMessages.current
          .filter((x) => x.relatedId == theBotMessage.id)
          .at(0);
        if (currentRelated) {
          theBotMessage.related = currentRelated;
          currentRelated.parent = theBotMessage;
        }
        readableMessages.current.push(theBotMessage);
        readableMessages.current = readableMessages.current.sort(
          (a, b) => new Date(a.when) - new Date(b.when)
        );
      } else {
        let exist = readableMessages.current
          .filter((x) => x.id == theBotMessage.relatedId)
          .at(0);
        if (!exist) {
          theBotMessage.solo = true;
          readableMessages.current.push(theBotMessage);
        } else {
          exist.related = theBotMessage;
          theBotMessage.parent = exist;
        }
      }
      setMessages([...readableMessages.current]);
      props.finishBotMessage();
    }
  }, [props.botMessage]);

  useEffect(() => {
    document.querySelectorAll('code').forEach((codeElement) => {
      if (
        !codeElement.parentElement ||
        codeElement.parentElement.tagName.toLowerCase() !== 'pre'
      ) {
        const preElement = document.createElement('pre');
        const codeText = codeElement.innerText.replace(/\n/g, '\n        ');
        const lines = codeText.split('\n');
        const indentedText = lines
          .map((line) => {
            const trimmedLine = line.trim(); // Remove espaços em branco no início e no final
            const leadingSpaces = line.length - trimmedLine.length;
            return '\t'.repeat(leadingSpaces) + trimmedLine;
          })
          .join('\n        ');

        codeElement.innerText = indentedText;
        codeElement.parentNode.insertBefore(preElement, codeElement);
        preElement.appendChild(codeElement);
      }
    });

    hljs.highlightAll();

    if (shouldScrollToBottom) scrollToBottom();

    // If no messages were sent at 10 seconds, update the message list to recalculate delayed message timer
    if (refreshTimer.current) clearTimeout(refreshTimer.current);

    refreshTimer.current = setTimeout(refreshDelays, 10000);

    return () => {
      if (refreshTimer.current) clearTimeout(refreshTimer.current);
    };
  }, [messages]);

  useEffect(() => {
    if (messageGpt?.trim()) {
      const sendData = async () => {
        let payload = {
          chatId: props.currentItem.id,
          message: messageGpt,
          async: true,
          target: parseInt(activeTab, 10),
          language: language?.value,
          voice: voice?.value,
          personality: personality?.value,
        };

        setMessageGpt('');
        const response = await props.sendChatMessage(payload);

        if (!fullMessages.current.find((x) => x.id == response)) {
          const currentTempMessage = {
            who: 'me',
            message: payload.message,
            when: getCurrentTime(),
            imageMessage: activeTab === '1', // userMessage?.trim().startsWith("/img"),
            id: response,
            temp: true,
          };

          fullMessages.current.push(currentTempMessage);
          readableMessages.current.push(currentTempMessage);

          setMessages([...readableMessages.current]);
        }
      };

      sendData();
    }
  }, [messageGpt]);

  const handleDownload = (imageUrl) => {
    const fileName = getCurrentTime() + '.png';

    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        saveAs(blob, fileName);
      })
      .catch((error) => {});
  };

  const handleSend = async () => {
    setMessageGpt(userMessage);
    setUserMessage('');
    setShouldScrollToBottom(true);

    setTimeout(() => {
      scrollToBottom();
    }, 200);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    } else if (event.key === 'Enter') {
      if (
        event.shiftKey ||
        event.ctrlKey ||
        event.altKey ||
        event.metaKey ||
        event.ctrlKey
      ) {
        event.preventDefault();
      } else {
        handleSend();
      }
    }
  };

  const formatDate = (dateString) => {
    const formattedDate = moment
      .utc(dateString)
      .tz(moment.tz.guess())
      .format('YYYY-MM-DD HH:mm');
    // const formattedDate = moment.utc(dateString).add(5, 'hours').tz(moment.tz.guess()).format("YYYY-MM-DD HH:mm");
    return formattedDate;
  };

  const sendMessageWS = async (target, messageId, imageNumber) => {
    try {
      if (state.hubConnection.state === HubConnectionState.Disconnected) {
        await state.hubConnection.start();
      }

      let payload = {};
      if (messageId) payload['messageId'] = messageId;

      if (imageNumber != null) payload['imageNumber'] = imageNumber;

      await state.hubConnection.invoke(target, payload);
    } catch (error) {
      console.error('Error: ', error);
      return false;
    }
    return true;
  };

  const variateImage = async (messageId, imageNumber) => {
    let worked = false;
    if (state.hubConnection) {
      worked = await sendMessageWS('VariateImage', messageId, imageNumber);
    }

    if (!worked) {
      axios
        .post(config.API_HM + '/images/variate', {
          messageId: messageId,
          imageNumber: imageNumber,
        })
        .catch(function (error) {});
    }
  };

  const upscaleImage = async (messageId, imageNumber) => {
    let worked = false;
    if (state.hubConnection) {
      worked = await sendMessageWS('UpscaleImage', messageId, imageNumber);
    }

    if (!worked) {
      axios
        .post(config.API_HM + '/images/upscale', {
          messageId: messageId,
          imageNumber: imageNumber,
        })
        .catch(function (error) {});
    }
  };

  const handleInpaint = async (messageId) => {
    //setShowInpaint(true);
    //return;
    let worked = false;
    if (state.hubConnection) {
      worked = await sendMessageWS('InpaintImage', messageId);
    }

    axios
      .post(config.API_HM + '/images/inpaint', {
        messageId: messageId,
      })
      .catch(function (error) {});
  };

  const languageOptions = [
    { value: 'English', label: 'English' },
    { value: 'Portuguese', label: 'Portuguese' },
  ];

  const voiceOptions = [
    { value: 'Female', label: ' Female' },
    { value: 'Male', label: 'Male' },
  ];

  const personalityOptions = [
    { value: 'Friendly', label: 'Friendly' },
    { value: 'Neutral', label: 'Neutral' },
  ];

  const popUpContent = (
    <div className='tone-options'>
      <Row>
        <Col md={4}>
          <p>&#127758; Select language</p>
          <FieldSelect
            label={`Language`}
            options={languageOptions}
            id={`lang`}
            name={`lang`}
            onChange={setLanguage}
            value={language}
          />
        </Col>
        <Col md={4}>
          <p>&#128483; Select voice</p>
          <FieldSelect
            label={`Voice`}
            options={voiceOptions}
            id={`voice`}
            name={`voice`}
            onChange={setVoice}
            value={voice}
          />
        </Col>
        <Col md={4}>
          <p>&#127917; Select personality</p>
          <FieldSelect
            label={`Personality`}
            options={personalityOptions}
            id={`personality`}
            name={`personality`}
            onChange={setPersonality}
            value={personality}
          />
        </Col>
      </Row>
    </div>
  );

  const fixMessageParagraph = (message) => {
    if (!message) return message;

    const regex = /^<p>(.*?)<\/p>$/;
    const match = message.match(regex);

    if (match) return match[1];
    else return message;
  };

  const checkMessageDelay = (date) => {
    const momentNow = moment(new Date());
    const momentDate = moment(date);
    const delay = Math.abs(momentNow.diff(momentDate, 'minutes'));

    return delay;
  };

  const openHootsuiteMessage = (id, message) => {
    const idHs = id < 0 ? id : id * -1;
    const idOriginal = id > 0 ? id : id * -1;
    const hootSuiteOriginalMessage = fullMessages.current
      .filter((x) => x.id == idHs)
      ?.at(0);
    const originalMessage = fullMessages.current
      .filter((x) => x.id == idOriginal)
      ?.at(0);

    let theHootsuiteMessage = {
      id: idHs,
      who: 'bot',
      relatedId: id,
      message: '<small>' + originalMessage?.message + '</small>',
      parent: originalMessage,
      hootSuite: true,
      solo: true,
    };

    if (hootSuiteOriginalMessage) {
      const indexOriginalMessage = readableMessages.current.indexOf(
        hootSuiteOriginalMessage
      );

      theHootsuiteMessage = {
        id: idHs,
        who: 'bot',
        relatedId: id,
        message: '<small>' + message + '</small>',
        parent: originalMessage,
        hootSuite: true,
        solo: true,
      };

      const newArray = [...readableMessages.current];
      newArray[indexOriginalMessage] = theHootsuiteMessage;

      setMessages(newArray);
    } else {
      // Add this new message
      readableMessages.current.push(theHootsuiteMessage);
      fullMessages.current.push(theHootsuiteMessage);
      setMessages([...readableMessages.current]);
    }
  };

  const returnMessageContent = (x, key) => {
    if (!x.message) {
      // x.error = true;
      // x.message = "Oh no! It seems like something went wrong. Please try resending your prompt again. We apologize for the inconvenience.";
      x.message = 'K_THINKING';
    }

    let message = fixMessageParagraph(x.message);
    const isGuidelineError =
      message ==
      "We cannot fulfill that request due to ethical guidelines. Ask anything else and we'll be glad to help!";
    const isUpgradeError = message.indexOf('Upgrade Plan</a>') > -1;
    const isImageMessage = message.startsWith('https:');

    const hootSuiteMessage = x.hootSuite ? (
      <HootSuiteBox
        chatId={props.currentItem.id}
        id={x.id}
        target={x.target}
        message={message}
        messages={fullMessages?.current ?? []}
      />
    ) : null;

    const isHootsuiteIntegrated = localStorage.getItem('hst') !== null;
    return (
      <div key={key} ref={messagesRef}>
        {/* ERROR RETURN */}
        {x.error && (
          <Row
            className={`conversation-item conversation-${
              isGuidelineError || isUpgradeError ? 'denied' : 'error'
            } bot`}>
            <Col md={12}>
              <div className={`default-response bot-chat`}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <Image
                    radius={16}
                    src={RobotAvatar}
                    alt='alt'
                    width={32}
                    height={32}
                    marginRight={10}
                    classNames='robot-avatar'
                    style={{ flex: '0 0 32px' }}
                  />
                  <div
                    className={`${
                      isGuidelineError || isUpgradeError ? 'denied' : 'error'
                    }-content`}
                    mid={x.id}
                    tgt={x.target}
                    dangerouslySetInnerHTML={{ __html: message }}
                    style={{ alignSelf: 'center', flexGrow: 1 }}></div>
                  {!isGuidelineError && !isUpgradeError && (
                    <Image
                      src={GenerationError}
                      alt='alt'
                      width={32}
                      height={32}
                      marginRight={10}
                      style={{ flex: '0 0 40px' }}
                    />
                  )}
                </div>
                {!isGuidelineError && !isUpgradeError && x.parent && (
                  <div
                    className='error-original-request'
                    mid={x.id}
                    tgt={x.target}
                    dangerouslySetInnerHTML={{
                      __html: fixMessageParagraph(x.parent.message),
                    }}></div>
                )}
                {isGuidelineError && (
                  <a
                    style={{ marginLeft: 42, marginTop: -4, display: 'block' }}
                    className='denied-link'
                    href='https://tokenizedhq.com/list-of-banned-words-in-midjourney/'
                    target='_blank'>
                    learn more
                    <svg
                      style={{ marginLeft: 5 }}
                      width='14'
                      height='14'
                      viewBox='0 0 14 14'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M13.6663 7.00016C13.6663 3.31737 10.6825 0.333496 6.99967 0.333496C3.31688 0.333496 0.333008 3.31737 0.333008 7.00016C0.333008 10.683 3.31688 13.6668 6.99967 13.6668C10.6825 13.6668 13.6663 10.683 13.6663 7.00016ZM1.62333 7.00016C1.62333 4.02973 4.02924 1.62382 6.99967 1.62382C9.9701 1.62382 12.376 4.02973 12.376 7.00016C12.376 9.97059 9.9701 12.3765 6.99967 12.3765C4.02924 12.3765 1.62333 9.97059 1.62333 7.00016ZM3.55881 7.5378V6.46253C3.55881 6.28511 3.70398 6.13995 3.88139 6.13995H6.99967V4.33887C6.99967 4.05124 7.34645 3.90876 7.55075 4.11038L10.212 6.77167C10.3384 6.89801 10.3384 7.10231 10.212 7.22866L7.55075 9.88995C7.34645 10.0942 6.99967 9.94909 6.99967 9.66145V7.86038H3.88139C3.70398 7.86038 3.55881 7.71522 3.55881 7.5378Z'
                        fill='#3A3A3A'
                      />
                    </svg>
                  </a>
                )}
              </div>
            </Col>
          </Row>
        )}

        {/* THINKING FOR LESS THAN 5 MINUTES OR SUCCESSFULLY RETURN */}
        {(message != 'K_THINKING' ||
          (message == 'K_THINKING' && checkMessageDelay(x.when) < 5)) &&
          !x.error && (
            <Row
              className={`conversation-item ${
                x.who && x.who.toLowerCase() !== 'bot' ? 'me' : 'bot'
              }`}>
              <Col md={12}>
                <div
                  className={`default-response ${
                    x.who && x.who.toLowerCase() !== 'bot' ? 'me' : 'bot'
                  }-chat`}>
                  {message == 'K_THINKING' && (
                    <div className='thinking-dots-loader'>
                      <div className='dots'></div>
                    </div>
                  )}

                  {!isImageMessage &&
                    message != 'K_THINKING' &&
                    !x.hootSuite &&
                    x.target !== 'Hootsuite' && (
                      <div
                        className='main-chat-content'
                        mid={x.id}
                        tgt={x.target}
                        dangerouslySetInnerHTML={{ __html: message }}></div>
                    )}

                  {x.target === 'Hootsuite' && (
                    <HootSuiteBox
                      chatId={props.currentItem.id}
                      id={x.id}
                      target={x.target}
                      message={message}
                      messages={[]}
                      sentMessage={true}
                      sentImageUrl={x.imageUrl}
                    />
                  )}

                  {!isImageMessage &&
                    message != 'K_THINKING' &&
                    x.hootSuite &&
                    hootSuiteMessage}

                  {isImageMessage && (
                    <div
                      className={
                        x.canVariate || x.canUpscale
                          ? `image-variate-container`
                          : `image-complete`
                      }>
                      <div
                        className={
                          x.canVariate || x.canUpscale ? `quadrant one` : ``
                        }>
                        <div className='blur-bg'>
                          <div className='image-actions'>
                            {x.canVariate && (
                              <Button
                                className='variation-btn'
                                size='sm'
                                onClick={() => variateImage(x.id, 1)}>
                                Alternate Photo
                              </Button>
                            )}
                            {x.canUpscale && (
                              <Button
                                size='sm'
                                className='upscale-btn'
                                variant='success'
                                onClick={() => upscaleImage(x.id, 1)}>
                                Choose Image
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          x.canVariate || x.canUpscale ? `quadrant two` : ``
                        }>
                        <div className='blur-bg'>
                          <div className='image-actions'>
                            {x.canVariate && (
                              <Button
                                size='sm'
                                className='variation-btn'
                                onClick={() => variateImage(x.id, 2)}>
                                Alternate Photo
                              </Button>
                            )}
                            {x.canUpscale && (
                              <Button
                                size='sm'
                                className='upscale-btn'
                                variant='success'
                                onClick={() => upscaleImage(x.id, 2)}>
                                Choose Image
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          x.canVariate || x.canUpscale ? `quadrant three` : ``
                        }>
                        <div className='blur-bg'>
                          <div className='image-actions'>
                            {x.canVariate && (
                              <Button
                                size='sm'
                                className='variation-btn'
                                onClick={() => variateImage(x.id, 3)}>
                                Alternate Photo
                              </Button>
                            )}
                            {x.canUpscale && (
                              <Button
                                size='sm'
                                className='upscale-btn'
                                variant='success'
                                onClick={() => upscaleImage(x.id, 3)}>
                                Choose Image
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          x.canVariate || x.canUpscale ? `quadrant four` : ``
                        }>
                        <div className='blur-bg'>
                          <div className='image-actions'>
                            {x.canVariate && (
                              <Button
                                size='sm'
                                className='variation-btn'
                                onClick={() => variateImage(x.id, 4)}>
                                Alternate Photo
                              </Button>
                            )}
                            {x.canUpscale && (
                              <Button
                                size='sm'
                                className='upscale-btn'
                                variant='success'
                                onClick={() => upscaleImage(x.id, 4)}>
                                Choose Image
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className='full-image'>
                        <Image
                          className='main-chat-content'
                          classNames='ai-image'
                          src={message}
                          radius={20}
                        />

                        {x.isImage && (
                          <div className='blur-bg'>
                            <div className='image-actions'>
                              {/* <Button className="variation-btn" onClick={() => handleInpaint(x.id)}>
                              Alternate Region
                            </Button> */}
                              <Button
                                className='download-btn'
                                onClick={() => handleDownload(x.message)}>
                                Download Image
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </Col>
              <Row
                className={`${
                  x.who && x.who.toLowerCase() !== 'bot' ? 'me' : 'bot'
                }`}>
                {x.who && x.who.toLowerCase() !== 'bot' && (
                  <>
                    <Col md={12} className='d-flex justify-content-end p-0'>
                      <div className='user-meta-info'>
                        <Image
                          src={
                            x.sender
                              ? config.API_HM + '/profile/image/' + x.sender.id
                              : null
                          }
                          defaultSrc={
                            x.who?.toLowerCase() !== 'bot'
                              ? UserAvatar
                              : RobotAvatar
                          }
                          radius={16}
                          width={48}
                          height={48}
                          marginTop={-24}
                          classNames='user-avatar'
                        />
                        <div className='prompt-data'>
                          <small>{formatDate(x.when)}</small>
                          {x.target == 'Image' && (
                            <div className='type-image'>Image Generation</div>
                          )}
                          {x.target == 'Hootsuite' && !x.hootSuite && (
                            <div className='type-text'>Hootsuite Post</div>
                          )}
                          {x.target != 'Image' &&
                            x.target !== 'Hootsuite' &&
                            !x.hootSuite && (
                              <div className='type-text'>Text Generation</div>
                            )}
                          {x.hootSuite && (
                            <div className='type-text'>HootSuite post</div>
                          )}
                          {!x.related &&
                            !x.hootSuite &&
                            x.target !== 'Hootsuite' &&
                            checkMessageDelay(x.when) < 5 && (
                              <div className='thinking-dots-loader'>
                                <div className='dots'></div>
                              </div>
                            )}
                        </div>
                      </div>
                    </Col>
                  </>
                )}

                {!x.who ||
                  (x.who.toLowerCase() === 'bot' && (
                    <Col md={12}>
                      <div className='robot-meta-info'>
                        <div className='robot-saying'>
                          <Image
                            radius={16}
                            src={RobotAvatar}
                            alt='alt'
                            width={48}
                            height={48}
                            marginTop={-24}
                            classNames='robot-avatar'
                          />
                          <small>{formatDate(x.when)}</small>
                        </div>

                        {!x.isImage &&
                          !x.hootSuite &&
                          isHootsuiteIntegrated && (
                            <div
                              onClick={() => openHootsuiteMessage(x.id)}
                              className='hootsuite-button'>
                              Create Post
                            </div>
                          )}
                      </div>
                    </Col>
                  ))}
              </Row>
            </Row>
          )}

        {message == 'K_THINKING' && checkMessageDelay(x.when) >= 5 && (
          <Row className={`conversation-item conversation-error bot`}>
            <Col md={12}>
              <div className={`default-response bot-chat`}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <Image
                    radius={16}
                    src={RobotAvatar}
                    alt='alt'
                    width={32}
                    height={32}
                    marginRight={10}
                    classNames='robot-avatar'
                    style={{ flex: '0 0 32px' }}
                  />
                  <div
                    className='error-content'
                    mid={x.id}
                    tgt={x.target}
                    style={{ alignSelf: 'center', flexGrow: 1 }}>
                    Oh no! It seems like something went wrong. Please try
                    resending your prompt again. We apologize for the
                    inconvenience.
                  </div>
                  <Image
                    src={GenerationError}
                    alt='alt'
                    width={32}
                    height={32}
                    marginRight={10}
                    style={{ flex: '0 0 40px' }}
                  />
                </div>
                {x.parent && (
                  <div
                    className='error-original-request'
                    mid={x.id}
                    tgt={x.target}
                    dangerouslySetInnerHTML={{
                      __html: fixMessageParagraph(x.parent.message),
                    }}></div>
                )}
              </div>
            </Col>
          </Row>
        )}

        {/* THINKING BETWEEN 2 AND 5 MINUTES */}
        {message == 'K_THINKING' &&
          checkMessageDelay(x.when) >= 2 &&
          checkMessageDelay(x.when) < 5 && (
            <Row className={`conversation-item conversation-delay bot`}>
              <Col md={12}>
                <div className={`default-response bot-chat`}>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Image
                      radius={16}
                      src={RobotAvatar}
                      alt='alt'
                      width={32}
                      height={32}
                      marginRight={10}
                      classNames='robot-avatar'
                      style={{ flex: '0 0 32px' }}
                    />
                    <div
                      className='delay-content'
                      mid={x.id}
                      tgt={x.target}
                      style={{ alignSelf: 'center', flexGrow: 1 }}>
                      Don’t go anywhere, we are still working on generating your
                      prompt.
                    </div>
                    <Image
                      src={GenerationDelay}
                      alt='alt'
                      width={30}
                      height={32}
                      marginRight={10}
                      style={{ flex: '0 0 32px' }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          )}
      </div>
    );
  };

  return (
    <div style={{ height: '95vh', display: 'flex', flexDirection: 'column' }}>
      <div className='chat-header'>
        <h4>{title}</h4>
      </div>
      <Container
        style={{ flex: 1, overflowY: 'scroll' }}
        className='auto-refresh'>
        {messages.map((x, index) => {
          return (
            <div key={'message_container_' + index}>
              {returnMessageContent(x, index)}
              {!x.solo &&
                x.target !== 'Hootsuite' &&
                returnMessageContent(
                  x.related ?? {
                    who: 'bot',
                    message: 'K_THINKING',
                    when: x.when,
                    id: x.id + '_bot',
                    temp: true,
                    parent: x,
                  },
                  index + '_related'
                )}
            </div>
          );
        })}
      </Container>

      <div className='prompt-box'>
        {props.currentItem?.id > 0 && (
          <div className='prompt-box-inner'>
            <div className='prompt-box-input'>
              {isPopupOpen && (
                <Popup isOpen={isPopupOpen} content={popUpContent} />
              )}

              <Tabs
                activeKey={activeTab}
                onSelect={setActiveTab}
                style={{ marginTop: 20 }}>
                <Tab
                  eventKey='0'
                  title={
                    <div className='tab-content' style={{ display: 'flex' }}>
                      <div className='icon-tab-txt'>
                        <svg
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M8 15H10M10 15H12M10 15V5M10 5H5V6M10 5H15V6M3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19Z'
                            stroke-width='2'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                          />
                        </svg>
                      </div>
                      <span className='button-text'>ChatGPT</span>
                      {/* <Button className="trait-button" size="sm" variant="dark" style={{ marginLeft: "10px" }} onClick={isPopupOpen ? handleClosePopup : handleOpenPopup}>
                        {isPopupOpen ? `Save` : `Edit`} Traits
                      </Button> */}
                    </div>
                  }></Tab>
                <Tab
                  eventKey='1'
                  title={
                    <div className='tab-content'>
                      <div className='icon-tab-img'>
                        <svg
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M1.00005 16.0001C1 15.9355 1 15.8689 1 15.8002V4.2002C1 3.08009 1 2.51962 1.21799 2.0918C1.40973 1.71547 1.71547 1.40973 2.0918 1.21799C2.51962 1 3.08009 1 4.2002 1H15.8002C16.9203 1 17.4801 1 17.9079 1.21799C18.2842 1.40973 18.5905 1.71547 18.7822 2.0918C19 2.5192 19 3.07899 19 4.19691V15.8031C19 16.2881 19 16.6679 18.9822 16.9774M1.00005 16.0001C1.00082 16.9884 1.01337 17.5058 1.21799 17.9074C1.40973 18.2837 1.71547 18.5905 2.0918 18.7822C2.5192 19 3.07899 19 4.19691 19H15.8036C16.9215 19 17.4805 19 17.9079 18.7822C18.2842 18.5905 18.5905 18.2837 18.7822 17.9074C18.9055 17.6654 18.959 17.3813 18.9822 16.9774M1.00005 16.0001L5.76798 10.4375L5.76939 10.436C6.19227 9.9426 6.40406 9.69551 6.65527 9.60645C6.87594 9.52821 7.11686 9.53004 7.33643 9.61133C7.58664 9.70397 7.79506 9.95387 8.21191 10.4541L10.8831 13.6595C11.269 14.1226 11.463 14.3554 11.6986 14.4489C11.9065 14.5313 12.1357 14.5406 12.3501 14.4773C12.5942 14.4053 12.8091 14.1904 13.2388 13.7607L13.7358 13.2637C14.1733 12.8262 14.3921 12.6076 14.6397 12.5361C14.8571 12.4734 15.0896 12.4869 15.2988 12.5732C15.537 12.6716 15.7302 12.9124 16.1167 13.3955L18.9822 16.9774M18.9822 16.9774L19 16.9996M13 7C12.4477 7 12 6.55228 12 6C12 5.44772 12.4477 5 13 5C13.5523 5 14 5.44772 14 6C14 6.55228 13.5523 7 13 7Z'
                            stroke-width='2'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                          />
                        </svg>
                      </div>
                      <span className='button-text'>AI Image</span>
                    </div>
                  }></Tab>
              </Tabs>
              {/* <Autosuggest
                suggestions={options}
                onSuggestionSelected={onSuggestionSelected}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                shouldRenderSuggestions={shouldRenderSuggestions}
                inputProps={inputProps}
                className={`form-control`}
                onKeyDown={handleKeyDown}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
              /> */}

              <FieldTextarea
                label=''
                type='text'
                onChange={(x) => setUserMessage(x.target.value)}
                value={userMessage}
                required={true}
                classNames='w-100'
                rows={3}
                onKeyDown={handleKeyDown}
                maxLength={null}
                placeholder={'Ask anything...'}
              />
            </div>
            <div>
              <Button className='generate-button' onClick={handleSend}>
                Generate
              </Button>
            </div>
          </div>
        )}
      </div>

      <Modal
        className='inpaint-modal'
        size='lg'
        show={showInpaint}
        onHide={() => setShowInpaint(false)}>
        <Modal.Header closeButton={true} style={{ backgroundColor: '#151818' }}>
          <Modal.Title>Alternate Region</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: '#313338', paddingTop: 16 }}>
          <iframe
            id='inPaintFrame'
            style={{
              colorScheme: 'light',
              width: '100%',
              height: '100%',
              minHeight: 500,
            }}
            allow='autoplay; encrypted-media'
            referrerpolicy='origin'
            sandbox='allow-pointer-lock allow-scripts allow-same-origin allow-forms'
            src={
              showInpaint + '&frame_id=inPaintFrame&platform=desktop'
            }></iframe>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Conversation;
